// Dependencies.
import styled from 'styled-components'

import { Hero } from './Hero'
import { DropdownFields } from './DropdownFields'
import { TextFields } from './TextFields'
import { EventHookInterface } from '../../types'
import { WhatYoullDo } from './TextFields/WhatYoullDo'
import { RepeatEventSection } from './RepeatEventSection'
// Div.
const Div = styled.div``
export const Container = styled.div`
  .content {
    max-width: 1000px;
  }
`
// Props.
interface Props {
  eventHook: EventHookInterface
  hostGroupId?: number
  groupId?: number
  setGroupId: (id: number) => void
}

export const Event: React.FC<Props> = (props) => {
  return (
    <Div>
      <Hero
        eventHook={props.eventHook}
        hostGroupId={props.hostGroupId}
        setGroupId={props.setGroupId}
      />
      <Container>
        <RepeatEventSection eventHook={props.eventHook} />
        <WhatYoullDo eventHook={props.eventHook} />
        <DropdownFields eventHook={props.eventHook} groupId={props.groupId} />
        <TextFields eventHook={props.eventHook} />
      </Container>
    </Div>
  )
}
